export default __webpack_public_path__ + "static/zeton-2b719bea3b772c2ed648ede3787fad60.png";